import { useState } from "react";
import { submitReaddyForm } from "@/utils/submitForm";

const SUBSCRIBE_URL = "https://readdy.ai/api/form/dahflq3oh653ivfvntg0";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    setStatus("loading");
    setFeedback("");

    const result = await submitReaddyForm(SUBSCRIBE_URL, formEl, "company_alt", "订阅成功，新线索整理好会第一时间通知你。");
    if (result.ok) {
      setStatus("success");
      setFeedback(result.message);
      formEl.reset();
    } else {
      setStatus("error");
      setFeedback(result.message);
    }
  };

  return (
    <div className="w-full">
      {status === "success" ? (
        <div className="flex items-start gap-3 p-4 rounded-lg bg-secondary-50 border border-secondary-200">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
            <i className="ri-check-line text-lg" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-bold text-secondary-900">订阅成功</p>
            <p className="mt-1 text-sm text-secondary-800">{feedback}</p>
          </div>
        </div>
      ) : (
        <form
          data-readdy-form
          id="subscribe-form"
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-2 w-full"
          noValidate
        >
          <div className="assist-field-wrap" aria-hidden="true">
            <label htmlFor="company_alt">公司名称（请勿填写）</label>
            <input
              id="company_alt"
              name="company_alt"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
            />
          </div>

          <div className="relative flex-1">
            <i
              className="ri-mail-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400"
              aria-hidden="true"
            />
            <label htmlFor="subscribe-email" className="sr-only">
              邮箱地址
            </label>
            <input
              id="subscribe-email"
              name="email"
              type="email"
              required
              placeholder="留下邮箱，接收每周线索汇总"
              className="w-full h-11 pl-10 pr-3 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
            />
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {status === "loading" ? "提交中…" : "订阅更新"}
          </button>
        </form>
      )}

      {status === "error" && (
        <p className="mt-2 text-sm text-primary-700" role="alert">
          {feedback}
        </p>
      )}
    </div>
  );
}